import { Field, FieldArray } from "formik";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import AudioRecordButton from "../../components/form/AudioRecordButton";

function DeliveryNoteCommentsForm({ field, setFieldValue, values = [], canManageComment = () => true }) {
  const { t } = useTranslation();
  return (
    <div>
      <FieldArray
        name="comments"
        render={(arrayHelpersComments) => (
          <div className="row gx-0 align-items-center">
            <div className="col">
              <div className="card border-0 mb-4">
                <div className="card-header h6 mb-0 bg-none p-3">
                  <i className="fa fa-comments fa-lg fa-fw text-dark text-opacity-50 me-1" /> {t("menu.comments")}
                </div>
                <div className="card-body">
                  {values.map((comment, comment_index) => {
                    const canManage = !comment.id || canManageComment(comment);

                    return (
                      <Fragment key={`comment-${comment.id}-${comment_index}`}>
                        <div className="row align-items-center my-2">
                          <div className="col">
                            <label
                              className={`form-label ${comment_index > 0 ? "d-lg-none" : ""}`}
                              htmlFor={`${field}[${comment_index}].text`}
                            >
                              {t("menu.comment")}
                            </label>
                            <div className="d-flex gap-1 align-items-start">
                              <Field
                                as="textarea"
                                rows={3}
                                name={`comments.${comment_index}.text`}
                                className="form-control"
                                disabled={!canManage}
                              />
                              <AudioRecordButton
                                disabled={!canManage}
                                onTranscription={(text) => {
                                  const current = values[comment_index]?.text || "";
                                  setFieldValue(`comments.${comment_index}.text`, current ? `${current} ${text}` : text);
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <hr className="d-lg-none" />
                        {comment_index + 1 === values.length && (
                          <div className="row">
                            <div className="col col-lg-2">
                              <div className="btn-group w-100">
                                <button
                                  type="button"
                                  onClick={() =>
                                    arrayHelpersComments.push({
                                      text: "",
                                      id: null,
                                    })
                                  }
                                  className="btn btn-success"
                                >
                                  <i className="fa fa-plus"></i>
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    if (_.eq(comment_index, 0) && _.eq(values.length, 1)) {
                                      setFieldValue(`comments.${comment_index}`, {
                                        text: "",
                                        id: null,
                                      });
                                    } else {
                                      arrayHelpersComments.remove(comment_index);
                                    }
                                  }}
                                  className="btn btn-danger"
                                >
                                  <i className="fa fa-minus" />{" "}
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
      />
    </div>
  );
}

DeliveryNoteCommentsForm.propTypes = {
  field: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      created_by: PropTypes.shape({ id: PropTypes.number }),
    }),
  ),
  canManageComment: PropTypes.func,
};

export default DeliveryNoteCommentsForm;
